import { render, staticRenderFns } from "./BecomeHost.vue?vue&type=template&id=a5d4fc06&scoped=true&"
var script = {}
import style0 from "./BecomeHost.vue?vue&type=style&index=0&id=a5d4fc06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d4fc06",
  null
  
)

export default component.exports